module.exports = __webpack_public_path__ + "static/img/index_carousel3_1.b33ae71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/index_carousel3_1.jpg
// module id = hs8N
// module chunks = 1